import React from 'react';
import { filterMessagesByTab } from './utils/gameUtils';

// Reusable team chat panel - replaces 4 duplicated chat blocks
const TeamChat = ({
  team,             // 'white' or 'black'
  messages,         // array of chat messages
  chatTab,
  setChatTab,
  messageInput,
  setMessageInput,
  onSendMessage,
  sending,
  currentUserEmail,
  isAdmin,
  chatRef,
  inputRef,        // optional ref for auto-focus
  title,           // optional custom title
}) => {
  const icon = team === 'white' ? '♔' : '♚';
  const displayTitle = title || (isAdmin ? `${team === 'white' ? 'White' : 'Black'} Team Chat` : 'Team Chat');

  const filteredMessages = filterMessagesByTab(messages, chatTab);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage(team);
    }
  };

  return (
    <div className={`team-chat ${team}-chat`}>
      <div className="chat-header">
        <span className="chat-icon">{icon}</span>
        <h3>{displayTitle}</h3>
      </div>
      <div className="chat-tabs">
        <button
          className={`chat-tab ${chatTab === 'chat' ? 'active' : ''}`}
          onClick={() => setChatTab('chat')}
        >
          Chat
        </button>
        <button
          className={`chat-tab ${chatTab === 'suggested' ? 'active' : ''}`}
          onClick={() => setChatTab('suggested')}
        >
          Suggested
        </button>
        <button
          className={`chat-tab ${chatTab === 'played' ? 'active' : ''}`}
          onClick={() => setChatTab('played')}
        >
          Played
        </button>
      </div>
      <div className="chat-messages" ref={chatRef}>
        {filteredMessages.length > 0 ? (
          filteredMessages.map((msg, index) => (
            <div
              key={index}
              className={`chat-message ${msg.email === currentUserEmail ? 'own-message' : ''} ${msg.isMove ? 'move-message' : ''} ${msg.isSuggestion ? 'suggestion-message' : ''} ${msg.isElimination ? 'elimination-message' : ''} ${msg.isRevival ? 'revival-message' : ''} ${msg.isRandom ? 'random-message' : ''} ${msg.isAdmin ? 'admin-message' : ''}`}
            >
              <div className="message-sender">
                {msg.sender}
                {msg.role && !msg.isMove && !msg.isSuggestion && <span className="message-role"> ({msg.role})</span>}
                {msg.isMove && <span className="move-badge">MOVE</span>}
                {msg.isSuggestion && <span className="suggestion-badge">SUGGEST</span>}
              </div>
              <div className="message-text">{msg.message}</div>
              <div className="message-time">
                {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
          ))
        ) : (
          <p className="chat-placeholder">
            {chatTab === 'chat' && (isAdmin ? 'No messages yet.' : 'No messages yet. Start the conversation!')}
            {chatTab === 'suggested' && (isAdmin ? 'No suggestions yet.' : 'No suggestions yet. Drag a piece to suggest a move!')}
            {chatTab === 'played' && 'No moves played yet.'}
          </p>
        )}
      </div>
      <div className="chat-input-container">
        <input
          ref={inputRef}
          type="text"
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={isAdmin ? 'Send message as Admin...' : 'Type a message...'}
          disabled={sending}
          className="chat-input"
        />
        <button
          onClick={() => onSendMessage(team)}
          disabled={sending || !messageInput.trim()}
          className="chat-send-button"
        >
          {sending ? '...' : 'Send'}
        </button>
      </div>
    </div>
  );
};

export default TeamChat;
